import { StateCreator } from 'zustand'

import { ThemeState } from './types'

export const createThemeStateSlice: StateCreator<ThemeState, [], [], ThemeState> = (set) => ({
  isDarkMode: false,

  setIsDarkMode: (isDarkMode) => set(() => ({ isDarkMode })),
})
